/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

import Filter from "./components/Filter";

(function () {
  document.addEventListener('variant:changed', function (event) {
    if (event.detail) {
      var variant = event.detail.variant; // Gives you access to the whole variant details
      var selectElem = document.querySelector(
        '.select-wrapper.select-wrapper--primary>select'
      );
      var currentOption = Array.from(selectElem.options).filter(function (
        option
      ) {
        return option.value == variant.id;
      });
      var doesNotShipToPOBoxesId = 'does-not-ship-to-p-o-boxes',
        fulfilledByOurPartnerId = 'fulfilled-by-our-partner';
      if (
        currentOption.length &&
        currentOption[0].dataset.dropship === 'true'
      ) {
        if (!document.getElementById(fulfilledByOurPartnerId)) {
          _addLineItemInput(
            fulfilledByOurPartnerId,
            'Fulfilled By Our Partner'
          );
          var spanElem = document.createElement('span');
          spanElem.id = 'fullfilledByPartner';
          spanElem.style.display = 'block';
          spanElem.innerHTML =
            '<span id="fullfilledByPartner" style="display: block; margin-top: 20px;">\n' +
            'Fulfilled By Our Partner<br />\n' +
            '<span style="font-size: 14px;">Allow 2-3 business days for processing. Does not ship to P.O.Boxes</span>\n' +
            '</span>';
          document
            .querySelector('.product-form__payment-container')
            .parentNode.insertBefore(
              spanElem,
              document.querySelector('.product-form__payment-container')
                .nextSibling
            );
          if (!document.getElementById(doesNotShipToPOBoxesId)) {
            _addLineItemInput(
              doesNotShipToPOBoxesId,
              'Does not ship to P.O.Boxes'
            );
          }
        }
      } else {
        var spanElem = document.getElementById('fullfilledByPartner');
        if (spanElem) {
          spanElem.remove();
          document.getElementById(fulfilledByOurPartnerId).remove();
          document.getElementById(doesNotShipToPOBoxesId).remove();
        }
      }
    }

    function _addLineItemInput(id, title) {
      var lineItemProp = document.createElement('input');
      lineItemProp.id = id;
      lineItemProp.type = 'hidden';
      lineItemProp.name = 'properties[' + title + ']';
      lineItemProp.value = '✓';
      document
        .querySelector('.product-form__info-list')
        .appendChild(lineItemProp);
    }
  });

  var ProductColors = (function () {
    'use strict';
    var _maxAvailableColors = 6;
    var _altColorElem = document.getElementById('product-form__alt-colors');
    var _title = _getPropFromDataset(_altColorElem, 'title').replace("'", "'");
    var _cHandle = _getPropFromDataset(_altColorElem, 'handle');
    var _type = _getPropFromDataset(_altColorElem, 'type');
    var _token = _getPropFromDataset(_altColorElem, 'token');
    var _clsvensty = _getPropFromDataset(_altColorElem, 'clsvensty');
    var _titleRemoveData = ['Metatarsal', 'Neutral', 'Post'];
    _titleRemoveData.filter((val) => {
      _title = _title.replace(val, '').trim();
    })
    var _query = '\n{\nproducts(first: 250, query: "title:\''
      .concat(_title, "' AND product_type:")
      .concat(
        _type,
        '") {\n      edges {\n        node {\n          handle\n      availableForSale\n     images(first: 1) {\n            edges {\n              node {\n                transformedSrc(maxHeight:55)\n              }\n            }\n          }\n          metafield(key: "ip_ids", namespace: "twc") {\n        value\n    }\n        }\n      }\n    }\n  }\n'
      );
    
    var _settings = {
      async: true,
      crossDomain: true,
      url: '/api/graphql',
      method: 'POST',
      headers: {
        'X-Shopify-Storefront-Access-Token': _token,
        'Content-Type': 'application/graphql',
      },
      data: _query,
    };
    var altHTML = '';

    function _getPropFromDataset(element, prop) {
      if (element && element.dataset !== null) {
        return element.dataset[prop];
      }

      return '';
    }

    function _buildShowAllColorsLink(colorsAmount) {
      var showAllColorsLink = '';
      if (colorsAmount > _maxAvailableColors) {
        /*showAllColorsLink = '<span id="product-form__show-all-colors" tabindex="0">Show all ' + colorsAmount + ' colors</span>';  */
        showAllColorsLink = `<a href="#" id="product-form__show-all-colors">Show all ${colorsAmount} colors</a>`;
      }

      return showAllColorsLink;
    }

    function _getColors() {
      if (_title && _type) {
        $.ajax(_settings).done(function (response) {
          var pedgs = response.data.products.edges;
          var colorsAmount = 1;
          var currentColor = '';
          var activeProduct = '';
          let issetFootbed = false;
          let archTypeByNames = new Map([
            ["Neutral" , ''],
            ["Metatarsal" , ''],
            ["Post" , '']
          ])

          let arrActive = [];
          let arrNoActive = [];
          for (var i = 0; i < pedgs.length; i++) {
            let availableForSale = pedgs[i].node.availableForSale;
            if (availableForSale) {
              arrActive.push(pedgs[i]);
            } else {
              arrNoActive.push(pedgs[i]);
            }
          }
          pedgs = arrActive.concat(arrNoActive);
          
          if (arrActive.length <= 1) return; // when 1 color not show colors
  
          for (var i = 0; i < pedgs.length; i++) {
            var meta2 = pedgs[i].node.metafield;
            var imgs2 = pedgs[i].node.images.edges;
            if (imgs2.length == 0 || meta2 == null) continue;
            var parsedMeta2 = JSON.parse(meta2.value);
            var hndl2 = pedgs[i].node.handle;
            if (hndl2 === _cHandle) {
              activeProduct = parsedMeta2;
            }
          }
          

          for (var i = 0; i < pedgs.length; i++) {
            var hndl = pedgs[i].node.handle;
            var imgs = pedgs[i].node.images.edges;
            var meta = pedgs[i].node.metafield;
            var available = pedgs[i].node.availableForSale;
            let selectedClass = ' ';
            var unavailableClass = '';
            if (!available) {
              continue; // hide unavailable colors
              // unavailableClass = 'unavailable-variant';
            }

            if (imgs.length == 0 || meta == null) continue;
            var parsedMeta = JSON.parse(meta.value);
  
            if (hndl === _cHandle) {
              selectedClass = ' product-form__active-color';
            }
  
            function renderFootbed() {
              let altFootbedHtml = `<a class="select-foot-arch-item" href="/products/${pedgs[i].node.handle}">
            <div class="select_input-check">
              <label for="abeo-cecile-neutral-sand-nubuck_1">
              <div class="foot-arch-image ${selectedClass}">`
    
              if (parsedMeta.arch_type === 'Neutral') {
                altFootbedHtml += `<img src=${window.theme.imageFootbedNeutral}>`
              } else if (parsedMeta.arch_type === 'Metatarsal') {
                altFootbedHtml += `<img src=${window.theme.imageFootbedMetatarsal}>`
              } else if (parsedMeta.arch_type === 'Post') {
                altFootbedHtml += `<img src=${window.theme.imageFootbedPost}>`
              } else {
                altFootbedHtml += `<img src="//www.abeofootwear.com/cdn/shop/files/Untitled-6.png?v=1689228160">`
              }
    
              altFootbedHtml += `</div>
              <div class="foot-arch-content">

            <p><strong>${parsedMeta.arch_type} Footbed: </strong>`;
              if (parsedMeta.arch_type === 'Neutral') {
                altFootbedHtml += window.theme.footbedDescrtiptionNeutral
              } else if (parsedMeta.arch_type === 'Metatarsal') {
                altFootbedHtml += window.theme.footbedDescrtiptionMetatarsal
              } else if (parsedMeta.arch_type === 'Post') {
                altFootbedHtml += window.theme.footbedDescrtiptionPost
              } else {
                altFootbedHtml += ''
              }
              altFootbedHtml += `</p>

            </div>
                </label>
              </div>
            </a>`;
              return altFootbedHtml;
            }
  
            if (_clsvensty && _clsvensty !== parsedMeta.clsvensty && ((activeProduct.color === null && parsedMeta.color === null) || activeProduct.color.trim().toLowerCase() === parsedMeta.color.trim().toLowerCase())) {
              if (parsedMeta.arch_type) {
                archTypeByNames.set(parsedMeta.arch_type, renderFootbed());
                issetFootbed = true;
              }
            } else if (_clsvensty && _clsvensty === parsedMeta.clsvensty && ((activeProduct.color === null && parsedMeta.color === null) || activeProduct.color.trim().toLowerCase() === parsedMeta.color.trim().toLowerCase()))  {
              if (parsedMeta.arch_type) {
                archTypeByNames.set(parsedMeta.arch_type, renderFootbed());
                issetFootbed = true
              }
            }
            
            if (parsedMeta.color == null) continue;

            if (hndl === _cHandle) {
              currentColor = parsedMeta.color;
              altHTML += `<a class="product-form__active-color ${unavailableClass}" href="/products/${hndl}">
                        <span>Sold out</span><img src="${imgs[0].node.transformedSrc}" alt="${currentColor}" />
                    </a>`;
              // continue;
            }
  
            
  
            if (hndl === _cHandle) {
              continue;
            }
  
            if (_clsvensty !== parsedMeta.clsvensty) continue;
    
    
            var clr = parsedMeta.color;
            if (colorsAmount < _maxAvailableColors + 1) {
              altHTML += `<a class="${unavailableClass}" href="/products/${hndl}">
                    <span>Sold out</span><img src="${imgs[0].node.transformedSrc}" alt="${clr}" /></a>`;
            } else {
              altHTML += `<a class="product-form__hidden-color ${unavailableClass}" href="/products/${hndl}">
                    <span>Sold out</span><img src="${imgs[0].node.transformedSrc}" alt="${clr}" /></a>`;
            }
            colorsAmount++;
          }

          var showAllColorsLink = _buildShowAllColorsLink(colorsAmount);
          if (altHTML !== '') {
            $('#product-form__alt-colors').html(
              `<span class="product-form__option-name text--strong" style="display: block;">Color: ${currentColor}</span>
                <div class="altclrc">${altHTML}</div>${showAllColorsLink}`
            );
          }
  
          if (issetFootbed && _cHandle.includes('abeo')) {
            let footbed = `<div style="display: flex; margin-bottom: 15px" class="select_foot_row">`;
            archTypeByNames.forEach(function (value, key) {
              if (value) {
                footbed += value;
              }
            })
            footbed += `</div>`;
            $("#altFootbed").html(footbed)
            $('.select_fott-arch-heading').css('display', 'block');
          }
        });
      }
    }

    function _showAllColors() {
      $('#product-form__alt-colors .product-form__hidden-color').removeClass(
        'product-form__hidden-color'
      );
    }

    return {
      getColors: _getColors,
      showAllColors: _showAllColors,
    };
  })();

  ProductColors.getColors();
  $(document).ready(function () {
    $('#product-form__alt-colors').on(
      'click',
      '#product-form__show-all-colors',
      function (e) {
        ProductColors.showAllColors();
        $(this).remove();
      }
    );
  });

  var Cart = (function () {
    'use strict';

    function _addFreeProduct(freeProduct) {
      if (!freeProduct.hasOwnProperty('id')) {
        return;
      }

      var data = {
        quantity: 1,
        id: freeProduct.id,
        properties: {
          __min_subtotal_price: window.theme.minCartSubtotalForFreeItem,
          __free_item: 'free',
        },
      };

      return _add(data);
    }

    function _add(data) {
      return fetch('/cart/add.js', _preparePostData(data)).then(function (res) {
        document.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
          })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
          })
        );
        return res.json();
      });
    }

    function _remove(id) {
      var data = {
        id: id,
        quantity: 0,
      };

      return fetch('/cart/change.js', _preparePostData(data)).then(function (
        res
      ) {
        document.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
          })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
          })
        );

        return res.json();
      });
    }

    function _updateQuantity(id, quantity) {
      var data = {
        updates: {
          [id]: quantity,
        },
      };

      return fetch('/cart/update.js', _preparePostData(data)).then(function (
        res
      ) {
        document.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
          })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
          })
        );

        return res.json();
      });
    }

    function _preparePostData(data) {
      return {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      };
    }

    function _getCart() {
      return fetch('/cart.js').then(function (res) {
        return res.json();
      });
    }

    function _updateNote(note, callback) {
      return fetch('/cart/update.js', _preparePostData({ note: note }));
    }

    function _onCartUpdated() {
      fetch(window.theme.localeRootUrl + '/cart.js')
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          if (Array.isArray(dataLayer)) {
            if (cart.items.length === 0) {
              dataLayer.push({ event: 'cart_empty', optiCart: {} });
            } else {
              dataLayer.push({ event: 'cart_updated', optiCart: cart });
            }
          }
        })
        .catch(function (err) {});
    }

    return {
      removeAddonProduct: _remove,
      addFreeProduct: _addFreeProduct,
      get: _getCart,
      remove: _remove,
      updateNote: _updateNote,
      updateQuantity: _updateQuantity,
      onCartUpdated: _onCartUpdated,
    };
  })();

  function addFreeProduct(cart) {
    var cartSubtotal = 0;
    cart.items.forEach(function (item) {
      if (!item.properties.hasOwnProperty('__free_item')) {
        cartSubtotal += item.final_line_price / 100;
      }
    });

    var isFreeProductAdded = false;

    cart.items.forEach(function (item) {
      if (item.id == window.theme.freeItem.id) {
        isFreeProductAdded = true;
      }
    });

    if (
      window.theme.freeItem &&
      !isFreeProductAdded &&
      cartSubtotal > window.theme.minCartSubtotalForFreeItem
    ) {
      Cart.addFreeProduct(window.theme.freeItem);
    } else if (
      window.theme.freeItem &&
      isFreeProductAdded &&
      cartSubtotal < window.theme.minCartSubtotalForFreeItem
    ) {
      Cart.remove(window.theme.freeItem.id.toString());
    }
  }

  if (window.theme.freeItemSku) {
    fetch('/search?view=free-item-json&q=' + window.theme.freeItemSku)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        window.theme.freeItem = data;
      });
  }

  document.addEventListener('product:added', function () {
    Cart.get().then(function (cart) {
      if (window.theme.freeItemEnabled) {
        addFreeProduct(cart);
      }
    });
  });

  document.addEventListener('product:added', function () {
    Cart.onCartUpdated();
  });

  document.addEventListener('variant:changed', function (event) {
    // final sale product
    addLineItemPropForFinalSaleProduct(event.detail.variant);
  });

  function addLineItemPropForFinalSaleProduct(variant) {
    var finalItemBlock = document.querySelector(
      '.message--final-clearence-item'
    );
    var lineItemElem = document.getElementById('final-clearence-item');
    var finalSaleProductPriceEnds = [97, 99];

    if (
      variant.price % 100 === finalSaleProductPriceEnds[0] ||
      variant.price % 100 === finalSaleProductPriceEnds[1]
    ) {
      if (finalItemBlock.style.display !== 'block') {
        finalItemBlock.style.display = 'block';
      }

      if (!lineItemElem) {
        var lineItemHtml =
          '<input id="final-clearence-item" type="hidden" name="properties[All sales final on clearance items]" value="✓"></input>';
        document.getElementById(
          'final-item-line-item-property'
        ).innerHTML = lineItemHtml;
      }
    } else {
      if (lineItemElem) {
        lineItemElem.remove();
        finalItemBlock.style.display = 'none';
      }
    }
  }

  if (window.location.pathname.indexOf('/cart') === 0 && window.theme.freeShippingEnabled) {
    document.getElementsByClassName('cart-wrapper')[0].style.minHeight = '600px';
  }

  // async load of zendesk app
  function asyncZendeskLoad() {
    var zendeskUrl =
      'https://cdn.shopify.com/s/files/1/0043/6840/0430/t/7/assets/zendesk-embeddable.js?948\u0026shop=walkingco.myshopify.com';
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = zendeskUrl;
    var x = document.getElementsByTagName('script')[0];
    setTimeout(function () {
      x.parentNode.insertBefore(s, x);
    }, 15000);
  }
  if (window.attachEvent) {
    window.attachEvent('onload', asyncZendeskLoad);
  } else {
    window.addEventListener('load', asyncZendeskLoad, false);
  }

  // get value from data attribute
  function geValueFromDataAttr(elem, name) {
    if (!elem) {
      return null;
    }

    return elem.dataset.hasOwnProperty(name) ? elem.dataset[name] : null;
  }

  //control product video in slider (START)

  var mainSlider = document.querySelector('.product-gallery__carousel');
  if (mainSlider !== null) {
    var players = getPlayers();
    if (Object.keys(players).length > 0) {
      var observer = new MutationObserver(processing);
      observer.observe(mainSlider, {
        attributeFilter: ['class'],
        childList: true,
        subtree: true,
        attributes: true,
      });
    }
  }

  /**
   *
   * @param mutations
   */
  function processing(mutations) {
    mutations.forEach(function (mutation) {
      var playerId = getCurrentPlayerIdFromMutation(mutation);
      if (playerId) {
        var state = getStatePlayerFromMutation(mutation);
        var player = players[playerId];
        switch (state) {
          case 'play':
            {
              player.play();
              player.muted = true;
              player.loop = true;
            }
            break;
          case 'pause':
            {
              player.pause();
            }
            break;
        }
      }
    });
  }

  /**
   *
   * @param mutation
   * @returns {string}
   */
  function getStatePlayerFromMutation(mutation) {
    return mutation.target.hasAttribute('aria-hidden') ? 'pause' : 'play';
  }

  /**
   *
   * @param mutation
   * @returns {string|null}
   */
  function getCurrentPlayerIdFromMutation(mutation) {
    var item = mutation.target;
    if (
      mutation.type === 'attributes' &&
      mutation.attributeName === 'class' &&
      item.hasAttribute('data-video')
    ) {
      return item.getAttribute('data-image-id');
    } else {
      return null;
    }
  }

  /**
   *
   */
  function getPlayers() {
    var playerWrappers = document.querySelectorAll(
      '.product-gallery__carousel [data-video]'
    );
    var players = {};
    playerWrappers.forEach(function (playerWrapper) {
      var id = playerWrapper.getAttribute('data-image-id');
      players[id] = playerWrapper.querySelector('video');
    });
    return players;
  }
  //control product video in slider (FINISH)
  
  let options = $('section[data-section-id="search-template"]').attr('data-section-settings');
  if (options !== undefined) {
    options = JSON.parse(options);
    if (options['isFilterSearch']) {
      new Filter(window.theme.token, window.theme.searchFilterGroup.split(', '));
    }
  }  
})();
